import React from 'react';
import {equipmentConfirmationQueue,equipmentQueueLabel} from '../equipmentConfirmationQueue';
export function EquipmentConfirmationList({jobs,shifts,onOpen,onBack}:{jobs:any[];shifts:any[];onOpen:(job:any,shiftId:string)=>void;onBack:()=>void}) {
 const queue=equipmentConfirmationQueue(jobs,shifts);
 const groups=Array.from(new Set(queue.map(row=>row.job.id))).map(id=>queue.filter(row=>row.job.id===id));
 return <section aria-label="Equipment confirmations" className="space-y-4">
  <button onClick={onBack} className="min-h-11 px-3 rounded-xl border border-white/20">Back to all jobs</button>
  <h2 className="text-xl font-bold">{equipmentQueueLabel(queue)}</h2>
  <p>Upcoming active work only. Past shifts are excluded; historical equipment remains available in each job’s Equipment Manager.</p>
  {!queue.length && <p>No upcoming shifts await equipment confirmation.</p>}
  {groups.map(rows=><article key={rows[0].job.id} className="rounded-2xl border border-white/15 p-4 space-y-3">
   <h3 className="font-bold">{rows[0].job.eventName || rows[0].job.event_name || rows[0].job.project_ref || 'Unnamed event'}</h3>
   {rows.map(({shift,status})=><div key={shift.id} className="rounded-xl bg-slate-900 p-3 space-y-2">
    <h4 className="font-semibold">{shift.shift_title || 'Unnamed shift'}</h4>
    <p>{shift.event_date || 'Date not set — Admin review required'}</p><p>{status}</p>
    <button className="min-h-11 px-3 rounded-xl border border-white/20" aria-label={`Open Equipment Manager for ${shift.shift_title || 'Unnamed shift'}`} onClick={()=>onOpen(rows[0].job,shift.id)}>Open Equipment Manager</button>
   </div>)}
  </article>)}
 </section>;
}
